export default __webpack_public_path__ + "images/1fa884b6feae7d332e058b8a497ea45b.svg";